<template>
  <div class="flex flex-col">
    <div
      v-if="redirectTarget"
      class="sticky top-18 z-50 h-10 px-6 flex items-center flex-shrink-0 border-b border-slate-400 bg-slate-200"
    >
      <router-link :to="redirectTarget" class="flex items-center gap-2">
        <BlIcon icon="chevron-left" class="w-6 h-6" />
        <BlTextBody2
          :text="redirectLabel || redirectTarget.replaceAll('/', ' ')"
          class="capitalize-first"
        />
      </router-link>
    </div>

    <div class="w-full bg-slate-100 flex justify-center py-6">
      <div
        class="bg-pure-white rounded-3xl w-200 h-min relative border border-grey-200"
      >
        <div v-if="pageLoading" class="h-200 w-200 grid place-items-center">
          <div class="blum-loader"></div>
        </div>
        <TabSession
          v-else
          description="Here is detailed information about your therapist's session history."
          :therapistName="user.name"
          :basePath="`/team/session-history/${userId}?`"
          :userId="Number(userId)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TabSession from "../profile/TabSession.vue";

import BlIcon from "../BlIcon.vue";
import BlTextBody2 from "../BlTextBody2.vue";

export default {
  name: "TeamSessionHistory",
  components: { TabSession, BlIcon, BlTextBody2 },
  data() {
    return {
      pageLoading: true,
      userId: 0,
      redirectTarget: "",
      redirectLabel: ""
    };
  },
  computed: {
    ...mapGetters(["user", "currentUser"])
  },
  created() {
    this.redirectTarget = this.$route.params.redirect_target || "/team";
    this.redirectLabel = this.$route.params.redirect_label || "Team";
  },
  async mounted() {
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }

    this.userId = this.$route.params.user_id;
    this.pageLoading = true;
    await this.getUser({ id: this.userId });
    this.pageLoading = false;
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    ...mapActions(["getUser"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/team/SessionHistory.vue